<template>
  <article class="main app-main">
    <!-- <header>
      <h2 class="top-title">国联人寿平台用户服务协议</h2>
    </header> -->
    <service-agreement />
  </article>
</template>

<script>
import ServiceAgreement from '@/views/PdfFiles/ServiceAgreement'
export default {
  name: 'UserLicense',
  components: {
    ServiceAgreement
  },
  mixins: [],
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style scoped lang="scss">
.main {
  padding: px2rem(15, 375);
  color: #333;
}

.top-title {
  text-align: center;
  font-size: px2rem(20, 375);
  margin-bottom: px2rem(20, 375);
}

section {
  line-height: 1.5;
}

.part-title {
  font-size: px2rem(14, 375);
  font-weight: bold;
  margin-bottom: px2rem(5, 375);
}

.user {
  font-weight: normal;
}

.clause-block {
  margin-bottom: px2rem(10, 375);
}

.part-content {
  font-size: px2rem(14, 375);
  text-indent: px2rem(28, 375);
  text-align: justify;
}

.text-underline {
  text-decoration: underline;
}
</style>
